export default __webpack_public_path__ + "81d1a00e8c69ca1fbe491dfa836417a9.svg";